import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-udsp-mapping',
  templateUrl: './udsp-mapping.component.html',
  styleUrls: ['./udsp-mapping.component.css']
})
export class UdspMappingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
